import JavascriptHelpers from "../components/lib/Javascript/JavascriptHelpers.js";

export default class ReceiptLine {
    constructor(lineId, lineNbr, poolId, poolName, blockId, blockName, commodityId, commodityName, styleId, styleName, sizeId, sizeName, uomId, uomName,
            labelId, labelName, methodId, methodName, regionId, regionName, varietyId, varietyName,storageId, storageName,
            itemPalletDefaultCubeQty, itemId, itemName, tagLineQty, aggregateLineQty, diffLineQty, tagLinePalletQty, pallets, grade, 
            growerId, growerName, growerNbr)
        {
        this.lineId = lineId || ""; 
        this.lineNbr = lineNbr || "";
        this.poolId = poolId || "";
        this.poolName = poolName || ""; 
        this.blockId = blockId || "";
        this.blockName = blockName || ""; 
        this.commodityId = commodityId || "";
        this.commodityName = commodityName || "";
        this.growerId = growerId || "";
        this.growerName = growerName || "";
        this.growerNbr = growerNbr || "";
        this.styleId = styleId || "";
        this.styleName = styleName || "";
        this.sizeId = sizeId || "";
        this.sizeName = sizeName || "";
        this.uomId = uomId || "";
        this.uomName = uomName || "";
        this.labelId = labelId || "";
        this.labelName = labelName || "";
        this.methodId = methodId || ""; 
        this.methodName = methodName || ""
        this.regionId = regionId || "";
        this.regionName = regionName || "";
        this.varietyId = varietyId || "";
        this.varietyName = varietyName || "";
        this.storageId = storageId || "";
        this.storageName = storageName || "";


        this.itemPalletDefaultCubeQty = itemPalletDefaultCubeQty || 0; 
        this.itemId = itemId || "";  
        this.itemName = itemName || "";

        this.tagLineQty = tagLineQty || 0;  
        this.aggregateLineQty = aggregateLineQty || 0; 
        this.diffLineQty = diffLineQty || 0;  
        this.tagLinePalletQty = tagLinePalletQty || 0; 

        this.grade = grade || "";

        this.pallets = pallets || []; 

        this.lotHash = 0;

    }


    toStableHash(hashLength){
        var hashString = 
            this.itemId + ":" +
            this.poolId + ":" +
            this.blockId + ":" +
            this.commodityId + ":" +
            this.styleId + ":" + 
            this.sizeId + ":" +
            this.uomId + ":" + 
            this.labelId + ":" +
            this.methodId + ":" +
            this.regionId + ":" +
            this.varietyId + ":" +
            this.storageId + ":" +
            this.grade;
            
        return JavascriptHelpers.getStableHash(hashString, hashLength);
    }




}